// extracted by mini-css-extract-plugin
export default {"pollModal":"PollNewUserModal_pollModal__PfquR"};